import * as jwt from "jsonwebtoken";
import { JwtPayload } from "../../common/types";

export const refreshTokenFactory = (magentoUrl: string, fetch: any = global["fetch"]) => {
  return async (existingToken: string | null): Promise<string> => {
    if (existingToken) {
      const decoded = jwt.decode(existingToken) as JwtPayload;
      if (decoded) {
        const expiry = new Date(decoded.exp * 1000);
        if (expiry > new Date()) {
          return existingToken; // Still valid
        }
      }
    }

    const response = await fetch(`${magentoUrl}/gca/auth`, { method: "GET", credentials: "include" });
    return (await response.json()).token;
  };
};
